import {ceil, floor} from "lodash";
import React from "react";
import {injectIntl, IntlShape} from "react-intl";

import {intl2Str} from "@translate/T";

export function toDuration(intl: IntlShape, value: number) {
    if (value === Infinity) {
        return intl2Str(intl, "unlimited");
    }

    let duration = "";
    // add days
    const days = floor(value / 3600 / 24);
    duration += days === 0 ? "" : days + intl2Str(intl, "DT");
    // add hours
    const hours = floor(value / 3600) % 24;
    duration += days + hours === 0 ? "" : twoDigits(hours) + ":";
    // add minutes
    const minutes = floor(value / 60) % 60;
    duration += twoDigits(minutes) + ":";
    // add seconds
    const seconds = ceil(value) % 60;
    duration += twoDigits(seconds);

    return duration;
}

function twoDigits(value: number) {
    return value < 10 ? "0" + value : value;
}

interface IDurationProps {
    intl: IntlShape;
    seconds: number;
}

/** converts seconds into readable duration */
class Duration extends React.PureComponent<IDurationProps> {
    public render() {
        const {intl, seconds} = this.props;
        return toDuration(intl, seconds);
    }
}

export default injectIntl(Duration);
